import { useRef } from 'react';
import { IconButton } from '@coolblue-development/becky';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createImageNode } from './ImageNode';
import ImageButton from '../../../Chat/InputForm/ImageButton';
import { tryInsertImage } from '../../../../../../utils/imageUploadUtils';

const SUPPORTED_IMAGE_TYPES = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/svg+xml',
  'image/webp',
  'image/bmp',
  'image/heif',
  'image/heic'
];

interface ImageUploadButtonProps {
  onBodySizeExceeded?: (exceeded: boolean) => void;
}

const ImageUploadButton = ({ onBodySizeExceeded }: ImageUploadButtonProps): JSX.Element => {
  const [editor] = useLexicalComposerContext();
  const inputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (): void => {
      editor.update(() => {
        tryInsertImage(editor, reader.result as string, (src: string) => $createImageNode({ src }), {
          imageType: file.type,
          onBodySizeExceeded
        });
      });
    };
    reader.readAsDataURL(file);

    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  const onClick = (): void => {
    inputRef.current?.click();
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={SUPPORTED_IMAGE_TYPES.join(',')}
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
      <IconButton
        preset="text"
        onClick={onClick}
        iconSize="small"
        data-testid="image-upload-button"
        sx={{
          width: 'auto',
          height: 'auto',
          padding: '8px',
          ':hover': { background: '#F3F3F3' }
        }}
      >
        <ImageButton />
      </IconButton>
    </>
  );
};

export default ImageUploadButton;
